// The product form can be swapped out after load (e.g. grouped product style swatches
// re-render .product-detail), so always look up the current elements instead of caching them.
const getAddToCartButton = () => document.getElementById("AddToCart");
// cloned button reference
let stickyButtonClone = null;

// add sticky add to cart
function addStickyAddToCart() {
  // Create a clone of the add to cart button to use for sticky positioning
  function createStickyButtonClone() {
    if (stickyButtonClone) return; // Avoid creating multiple clones

    // Clone the original button
    stickyButtonClone = getAddToCartButton().cloneNode(true);

    // Set a unique ID and add the sticky class
    stickyButtonClone.id = "AddToCartClone";
    stickyButtonClone.classList.add("StickyAddToCart");

    // Hide it initially
    stickyButtonClone.style.display = "none";

    // Append to the body
    document.body.appendChild(stickyButtonClone);

    // Match the original button's event listeners
    stickyButtonClone.addEventListener("click", function() {
      // When clicked, trigger a click on the current original button
      getAddToCartButton()?.click();
    });
  }

  // Create the clone when the function is called
  createStickyButtonClone();

  // add sticky add to cart when scrolling
  window.addEventListener("scroll", function () {
    // chat toggle
    const chatToggle = document.getElementById("ShopifyChat")?.shadowRoot?.querySelector("button.chat-toggle");

    if (window.scrollY > 1385) {
      // Show the sticky clone
      if (stickyButtonClone) {
        stickyButtonClone.style.display = "block";
      }

      // Update chat toggle if needed
      if (chatToggle) {
        chatToggle.style.borderColor = "#FFFFFF";
      }
    } else {
      // Hide the sticky clone
      if (stickyButtonClone) {
        stickyButtonClone.style.display = "none";
      }

      // Reset chat toggle
      if (chatToggle) {
        chatToggle.style.borderColor = "transparent";
      }
    }
  });

  // scroll to the top of the page when the add to cart button is clicked if no size is selected
  // (delegated so it keeps working after the product form is re-rendered)
  document.addEventListener("click", function (event) {
    const addToCartButton = event.target.closest("#AddToCart");
    if (!addToCartButton) return;

    const isNoSizeSelected = addToCartButton.classList.contains("no-size-selected");

    if (isNoSizeSelected && window.scrollY > 1385) {
      window.scrollTo({
        top: 250,
        behavior: "smooth",
      });
    }

    // if no size is selected, show the no items selected elements and add a border to the size buttons
    if (isNoSizeSelected) {
      document.querySelectorAll(".no-size-items-selected").forEach((element) => {
        element.classList.remove("hidden");
      });

      document.querySelectorAll(".option-selector__btns").forEach((element) => {
        element.classList.add("option-selector-border");
      });
    }
  });
}

// add sticky add to cart when the asset loads and the add to cart button is present
if (getAddToCartButton()) {
  addStickyAddToCart();
}